import React, { useState } from "react";
import { REPORT_MIN_MATCHES, isReportUnlocked } from "../reportGate";
import "./ReportCTA.scss";

export { REPORT_MIN_MATCHES };

const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3l1.9 4.6L18.5 9.5 13.9 11.4 12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z" />
    <path d="M19 14l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2z" />
  </svg>
);

const ChartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 3v18h18" />
    <rect x="7" y="12" width="3" height="6" rx="0.5" />
    <rect x="12" y="8" width="3" height="10" rx="0.5" />
    <rect x="17" y="5" width="3" height="13" rx="0.5" />
  </svg>
);

const ReportCTA = ({ inventoryId, totalMatches = 0, editMode = true }) => {
  const [hover, setHover] = useState(false);
  const unlocked = isReportUnlocked(totalMatches);

  const openReport = () => {
    if (!inventoryId) return;
    const url = editMode
      ? `/reports/active-buyer/${inventoryId}?edit=1`
      : `/reports/active-buyer/${inventoryId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (unlocked) {
    return (
      <button
        type="button"
        className="abr-entry-cta abr-entry-cta--ready"
        onClick={openReport}
        data-tour="download-report"
      >
        <ChartIcon />
        Generate Active Buyer Report
      </button>
    );
  }

  return (
    <div
      className="abr-entry-cta-wrap"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <button
        type="button"
        className="abr-entry-cta abr-entry-cta--soon"
        aria-disabled="true"
        data-tour="download-report"
        onClick={(e) => e.preventDefault()}
      >
        <span className="abr-entry-cta-shine" aria-hidden />
        <span className="abr-entry-cta-label">
          <SparkleIcon />
          Active Buyer Report
        </span>
        <span className="abr-entry-cta-soon">Coming soon</span>
      </button>

      {hover && (
        <div className="abr-entry-cta-tip" role="tooltip">
          <span className="abr-entry-cta-tip-eyebrow">
            <SparkleIcon />
            Almost there
          </span>
          <h4 className="abr-entry-cta-tip-title">Your buyer demand report is warming up</h4>
          <p className="abr-entry-cta-tip-body">
            This report turns on the moment there&apos;s enough active buyer demand
            in your market to make it count. The network is filling up fast - real
            buyers are matching to homes like yours every week. You&apos;ll have this
            very soon. Stay tuned.
          </p>
          <div className="abr-entry-cta-tip-preview" aria-hidden>
            <div className="abr-entry-cta-prev-tile">
              <div className="abr-entry-cta-prev-num is-1" />
              <div className="abr-entry-cta-prev-cap">Active buyers</div>
            </div>
            <div className="abr-entry-cta-prev-tile">
              <div className="abr-entry-cta-prev-num is-2" />
              <div className="abr-entry-cta-prev-cap">Peak demand</div>
            </div>
            <div className="abr-entry-cta-prev-tile">
              <div className="abr-entry-cta-prev-num is-3" />
              <div className="abr-entry-cta-prev-cap">Sweet spot</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportCTA;
